import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { GripVertical, PanelLeftClose, PanelLeftOpen, PanelRightClose, PanelRightOpen } from 'lucide-react'
import type { PointerEventHandler } from 'react'

type PaneResizeHandleProps = {
  edge: 'left' | 'right'
  collapsed: boolean
  resizeLabel: string
  collapseLabel: string
  expandLabel: string
  onResizeStart: PointerEventHandler<HTMLButtonElement>
  onToggle: () => void
}

export function PaneResizeHandle({
  edge,
  collapsed,
  resizeLabel,
  collapseLabel,
  expandLabel,
  onResizeStart,
  onToggle,
}: PaneResizeHandleProps) {
  const ToggleIcon =
    edge === 'right'
      ? collapsed
        ? PanelRightOpen
        : PanelLeftClose
      : collapsed
        ? PanelLeftOpen
        : PanelRightClose

  return (
    <div
      className={cn(
        'absolute top-0 z-20 hidden h-full w-4 items-center justify-center lg:flex',
        edge === 'right' ? 'right-0 translate-x-1/2' : 'left-0 -translate-x-1/2',
      )}
    >
      <button
        type="button"
        role="separator"
        aria-orientation="vertical"
        aria-label={resizeLabel}
        className="absolute inset-y-0 left-1/2 w-1 -translate-x-1/2 cursor-col-resize rounded-full bg-transparent transition-colors hover:bg-emerald-300 focus-visible:bg-emerald-300 focus-visible:outline-none"
        onPointerDown={onResizeStart}
      />
      <Button
        type="button"
        size="icon"
        variant="outline"
        aria-label={collapsed ? expandLabel : collapseLabel}
        title={collapsed ? expandLabel : collapseLabel}
        className="relative size-7 rounded-full border-emerald-200 bg-white text-emerald-700 shadow-sm hover:bg-emerald-50"
        onClick={onToggle}
      >
        <ToggleIcon className="size-3.5" />
        <GripVertical className="absolute -bottom-3 size-3 text-emerald-400" aria-hidden="true" />
      </Button>
    </div>
  )
}
